import { render, staticRenderFns } from "./UserGrid.vue?vue&type=template&id=10b8cbb8&scoped=true&"
import script from "./UserGrid.vue?vue&type=script&lang=js&"
export * from "./UserGrid.vue?vue&type=script&lang=js&"
import style0 from "./UserGrid.vue?vue&type=style&index=0&id=10b8cbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8cbb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChip,VChipGroup,VCol,VHover,VImg,VRow})
